// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2oDIV","info":"UpdateTermsInfo_info__3GPTd"};